export const GRAPH_ENDPOINT = "https://graph.microsoft.com/beta/me";
export const MAGIC_LINK_ENDPOINT =
	"https://apimgmt-pacificodesa.azure-api.net/ms-sp-genera-magic-link-pga/soporte-ti/v1/magic-links";
